import { collection, getDocs, query, orderBy, doc, getDoc } from 'firebase/firestore';
import { db } from '../../../../firebase/config';
import { fetchCompanyBankId } from '../../../companies/service/companiesService';

export type SelectedItem = {
    itemId: string;
    itemCode: string;
    itemName: string;
    quantity: number;
};

export type CCTVRequest = {
    id: string;
    requestId?: string;
    dateOfRequest?: string;
    branchCode?: string;
    branchName?: string;
    branchId?: string;
    vendor?: string;
    vendorId?: string;
    items?: SelectedItem[];
    remarks?: string;
    status?: string;
    cancelReason?: string;
    cancelledAt?: any;
    cancelledBy?: string;
    createdAt?: any;
    updatedAt?: any;
    createdBy?: string;
    requestType?: string;
    [key: string]: any;
};

/**
 * Fetch company ID for the current user (PSO or Bank user)
 */
export async function fetchCompanyId(uid: string, isBankUser: boolean = false): Promise<string | null> {
    try {
        return await fetchCompanyBankId(uid, isBankUser);
    } catch (error) {
        console.error('Error fetching company ID:', error);
        return null;
    }
}

/**
 * Fetch all CCTV requests for a company
 */
export async function fetchCCTVRequests(companyId: string): Promise<CCTVRequest[]> {
    if (!companyId) {
        return [];
    }

    try {
        const requestsSnap = await getDocs(
            query(
                collection(db, 'banks', companyId, 'hardware_requests'),
                orderBy('createdAt', 'desc')
            )
        );

        const requestsList = requestsSnap.docs
            .map(doc => ({
                id: doc.id,
                ...doc.data()
            }))
            .filter((request: any) => request.requestType === 'CCTV') as CCTVRequest[];

        return requestsList;
    } catch (error) {
        console.error('Error fetching CCTV requests:', error);
        throw error;
    }
}

